import React from "react";
import Item from "./item";
import FlashcardsIcon from "../../../icons/Flashcards";
import HighlighterIcon from "../../../icons/Highlighter";
import NotesIcon from "../../../icons/Notes";
import styled from "styled-components";
import cloud from "@vitalsource/vstui/colors/cloud";

const Wrapper = styled.div`
  display: flex;
  flex: 0 0 auto;
  min-height: 88px;
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
`;

const List = styled.ul`
  display: flex;
  flex-grow: 1;
  background-color: ${cloud.getShade(1)};
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    flex: 1;
    padding: 17px 0;
  }
`;

const Footer = ({ decks, highlights }) => {
  const notesCount = (highlights && highlights.noteCount) || 0;
  const highlightsCount = (highlights && highlights.highlightCount) || 0;
  if (notesCount >= 1 || highlightsCount >= 1 || decks.length >= 1) {
    return (
      <Wrapper>
        <List>
          {highlightsCount >= 1 && (
            <Item
              Icon={HighlighterIcon}
              count={highlightsCount}
              text={i18n.t("filter.highlights")}
            />
          )}
          {notesCount >= 1 && (
            <Item
              Icon={NotesIcon}
              count={notesCount}
              text={i18n.t("filter.notes")}
            />
          )}
          {decks.length >= 1 && (
            <Item
              Icon={FlashcardsIcon}
              count={decks.length}
              text={i18n.t("reader.flashcards.flashcard-decks")}
            />
          )}
        </List>
      </Wrapper>
    );
  }
  return null;
};

export default Footer;
